import {
    Budget,
    Institution,
    LanguageCode,
    MapBoxAddress,
    StrapiDocument,
    TimeStampAttributes,
    Topic,
    User
} from '@dh/types';

export enum MatchStatus {
    Draft = 'draft',
    Active = 'published',
    Done = 'closed'
}

export enum MatchingResultContactStatus {
    NoContact = 'none',
    ContactingAllowed = 'contacting',
    CommentingAllowed = 'commenting',
    Full = 'full'
}

export interface MatchingConfig {
    weight: {
        topic: number;
        principle: number;
    };
    topic: {
        displayPercentage: boolean;
        itemDisplayPercentage: boolean;
        threshold: number;
    };
    principle: {
        displayPercentage: boolean;
    };
    matching: {
        displayPercentage: boolean;
    };
}

export type FetchMatchingConfigResponse = {
    config?: MatchingConfig;
    error?: Error;
};

export interface MatchResult {
    institution: Institution;
    score: {
        total: number;
        topics: number;
        principles: number;
    };
    isNew?: boolean;
    contactStatus: MatchingResultContactStatus;
}

export type FetchMatchesInternalResponse = {
    matches: Match[];
    error?: Error;
    totalNumberOfEntries?: number;
};

export type FetchMatchInternalResponse = {
    match?: Match;
    error?: Error;
};

export interface Match extends TimeStampAttributes, StrapiDocument {
    title: string;
    description?: string;
    issuerInstitution: Institution;
    status: MatchStatus;
    contact?: User;
    updatedBy?: User;
    matchedInstitutions: MatchResult[];
    startDate?: Date;
    endDate?: Date;
    conditions: {
        dateOfFinalization?: Date;
        geographicRadius?: number;
        geographicAddress?: MapBoxAddress;
        budget?: Budget;
        languages?: LanguageCode[];
    };
    principles: (StrapiDocument & {
        title: string;
        description: string;
    })[];
    topics: Topic[];
    config?: MatchingConfig;
}
